import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "font-weight-bold mb-4" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Komponenten gruppiert")
], -1)
const _hoisted_5 = { class: "media bg-light font-weight-semibold py-2" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "rotate-180 mr-3" }
const _hoisted_8 = { class: "d-flex flex-row align-items-center flex-fill" }
const _hoisted_9 = {
  key: 0,
  class: "ml-2"
}
const _hoisted_10 = { class: "d-flex flex-row align-items-center" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "icon-cog" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("a", {
  href: "",
  class: "text-body",
  "data-toggle": "collapse",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-circle-down2" })
], -1)
const _hoisted_15 = ["id"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "media-body p-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "alert alert-info d-flex flex-row flex-wrap align-items-center" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-warning22 mr-3" }),
    /*#__PURE__*/_createElementVNode("p", { class: "flex-fill mr-3 mb-0" }, "In dieser Gruppe sind keine Kompnenten hinterlegt !")
  ])
], -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["onClick", "title"]
const _hoisted_20 = { class: "mr-3" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "media-body align-self-center" }
const _hoisted_23 = { class: "font-weight-semibold" }
const _hoisted_24 = { class: "text-muted" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "media-right align-self-center" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.headline), 1),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.componentGroups, (group, cIndex) => {
        return (_openBlock(), _createElementBlock("ul", {
          key: cIndex,
          class: "media-list media-list-linked media-list-bordered"
        }, [
          _createElementVNode("li", _hoisted_5, [
            _createElementVNode("a", {
              class: "text-body collapsed d-flex flex-row align-items-center justify-content-between w-100",
              href: '#collapse-icon'+cIndex,
              "data-toggle": "collapse"
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("a", {
                  class: _normalizeClass(["btn bg-transparent rounded-pill border-2 btn-icon", ['border-'+group.class, 'text-'+group.class]])
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass('text-'+group.class+' '+group.icon)
                  }, null, 2)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createTextVNode(_toDisplayString(group.name) + " ", 1),
                (group.alias && group.alias != '')
                  ? (_openBlock(), _createElementBlock("small", _hoisted_9, "(" + _toDisplayString(group.alias) + ")", 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_10, [
                (group.id)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      type: "button",
                      class: "btn btn-secondary-100 btn-sm text-secondary rotate-180 mr-2",
                      onClick: ($event: any) => (_ctx.editGroup(group.id))
                    }, _hoisted_13, 8, _hoisted_11))
                  : _createCommentVNode("", true),
                _hoisted_14
              ])
            ], 8, _hoisted_6)
          ]),
          _createElementVNode("div", {
            class: "collapse",
            id: 'collapse-icon'+cIndex
          }, [
            (group.items.length <= 0)
              ? (_openBlock(), _createElementBlock("li", _hoisted_16, _hoisted_18))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item, iIndex) => {
              return (_openBlock(), _createElementBlock("li", { key: iIndex }, [
                _createElementVNode("a", {
                  class: "media cursor-pointer align-items-center p-1 p-lg-2",
                  onClick: ($event: any) => (_ctx.getComponentFiles(item.id)),
                  title: '# '+item.id
                }, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("img", {
                      src: _ctx.$getFileUrl+'?t=_cloud&id='+item.imgKomponente+'&_token='+_ctx.user.accessToken,
                      class: "rounded",
                      alt: "",
                      width: "42",
                      height: "42"
                    }, null, 8, _hoisted_21)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, _toDisplayString(item.kurzname) + " (" + _toDisplayString(item.nummer) + ") ", 1),
                    _createElementVNode("div", _hoisted_24, _toDisplayString(item.standort) + " - " + _toDisplayString(item.bemerkung), 1)
                  ]),
                  _hoisted_25
                ], 8, _hoisted_19)
              ]))
            }), 128))
          ], 8, _hoisted_15)
        ]))
      }), 128))
    ])
  ]))
}